const theme = {
  // accent: "#AAFF00", // Bright Green
  // accentRgb: "170, 255, 0",
  // accentDark: "#77b300",

  // accent: "#0FFF50", // Neon Green
  // accentRgb: "15, 255, 80",
  // accentDark: "#0ab336",

  // accent: "#7FFFD4", // Aquamarine
  // accentRgb: "127, 255, 212",
  // accentDark: "#4db899",

  // accent: "#3F00FF", // Indigo
  // accentRgb: "63, 0, 255",
  // accentDark: "#2b00b3",

  // accent: "#1F51FF", // Neon Blue
  // accentRgb: "31, 81, 255",
  // accentDark: "#1438b3",

  // accent: "#40E0D0", // Turquoise
  // accentRgb: "64, 224, 208",
  // accentDark: "#2a9990",

  // accent: "#CF9FFF", // Light Violet
  // accentRgb: "207, 159, 255",
  // accentDark: "#9b6acc",

  // accent: "#DA70D6", // Orchid
  // accentRgb: "218, 112, 214",
  // accentDark: "#a34e9f",

  // accent: "#FF10F0", // Neon Pink
  // accentRgb: "255, 16, 240",
  // accentDark: "#b30ba8",

  // accent: "#F33A6A", // Rose
  // accentRgb: "243, 58, 106",
  // accentDark: "#b01a47",

  // accent: "#DC143C", // Crimson
  // accentRgb: "220, 20, 60",
  // accentDark: "#9a0e2a",

  // accent: "#FF3131", // Neon Red
  // accentRgb: "255, 49, 49",
  // accentDark: "#b32222",

  // accent: "#FF4433", // Red Orange
  // accentRgb: "255, 68, 51",
  // accentDark: "#b33024",

  // accent: "#FF5F1F", // Neon Orange
  // accentRgb: "255, 95, 31",
  // accentDark: "#b34215",

  // accent: "#FAFA33", // Lemon Yellow
  // accentRgb: "250, 250, 51",
  // accentDark: "#b3b324",

  accent: "#FFD700", // Gold Yellow
  accentRgb: "255, 215, 0",
  accentDark: "#b8960a",

  // accent: "#FAF9F6", // Off White
  // accentRgb: "250, 249, 246",
  // accentDark: "#c8c7c5",

  bg: "#0a0a0a",
  cardBg: "rgba(255, 255, 255, 0.03)",
  cardBorder: "rgba(255, 255, 255, 0.06)",
  textPrimary: "#ffffff",
  textSecondary: "rgba(255, 255, 255, 0.5)",
  font: "'Montserrat', sans-serif",
  mono: "'NeutralFace', sans-serif",
  buttonBg: "#121212",
};

export default theme;
